export default __webpack_public_path__ + "static/media/AmazonElastiCache.99d99be1.svg";